export var PartExOutstandingFinanceEquity;
(function(PartExOutstandingFinanceEquity) {
    PartExOutstandingFinanceEquity["Positive"] = "Positive";
    PartExOutstandingFinanceEquity["Negative"] = "Negative";
    PartExOutstandingFinanceEquity["No"] = "No";
})(PartExOutstandingFinanceEquity || (PartExOutstandingFinanceEquity = {}));
